import { useState, useEffect } from "react";
import { Modal, Button, Form, Table } from "react-bootstrap";
import axios from "axios";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";
import { useNavigate } from "react-router-dom";

const getAuthToken = () => localStorage.getItem("authToken");

const ExamManagement = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState([]);
  const [exams, setExams] = useState([]);
  const [batches, setBatches] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [staff, setStaff] = useState([]);
  const [examTypes, setExamTypes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [statuses, setStatuses] = useState([]);
  const [parentExams, setParentExams] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    exam_type_id: "",
    name: "",
    batch_id: "",
    subject_id: "",
    staff_id: "", // ← changed from coordinator_id
    total_mark: "",
    duration_minutes: "",
    exam_date: "",
    mode: "Objective",
    status_id: ""
  });
  

  useEffect(() => {
    fetchDropdownData();
    fetchExams();
  }, []);



  const fetchDropdownData = async () => {
    
    const token = getAuthToken();
    const headers = { Authorization: `Bearer ${token}` };
  
    try {
      const results = await Promise.allSettled([
        axios.get(`${appConstants.API_ROOT_URL}get-batches`, { headers }),
        axios.get(`${appConstants.API_ROOT_URL}get-subjects`, { headers }),
        axios.get(`${appConstants.API_ROOT_URL}get-staff`, { headers }),
        axios.get(`${appConstants.API_ROOT_URL}get-exam-types`, { headers }),
        axios.get(`${appConstants.API_ROOT_URL}get-exam-statuses`, { headers }),
        axios.get(`${appConstants.API_ROOT_URL}get-parent-exams`, { headers }),
      ]);
  
      const [batchRes, subjectRes, staffRes, typeRes, examStatusRes, paretnRes] = results;
  
      if (batchRes.status === "fulfilled") {
        setBatches(batchRes.value.data?.data || []);
      } else {
        console.error("Batch fetch error:", batchRes.reason);
      }
  
      if (subjectRes.status === "fulfilled") {
        setSubjects(subjectRes.value.data?.data || []);
      } else {
        console.error("Subject fetch error:", subjectRes.reason);
      }
  
      if (staffRes.status === "fulfilled") {
        setStaff(staffRes.value.data?.data || []);
      } else {
        console.error("Staff fetch error:", staffRes.reason);
      }
  
      if (typeRes.status === "fulfilled") {
        setExamTypes(typeRes.value.data?.data || []);
      } else {
        console.error("Exam types fetch error:", typeRes.reason);
      }

      if (examStatusRes.status === "fulfilled") {
        setStatuses(examStatusRes.value.data?.statuses || []);
      } else {
        console.error("Exam Status fetch error:", examStatusRes.reason);
      }

      if (paretnRes.status === "fulfilled") {
        setParentExams(paretnRes.value.data?.parent_exams || []);
      } else {
        console.error("Exam Status fetch error:", examStatusRes.reason);
      }
    } catch (err) {
      console.error("Unexpected error", err);
    }
  };
  
  

  const fetchExams = async () => {
    const token = getAuthToken();
    try {
      const res = await axios.get(`${appConstants.API_ROOT_URL}get-exams`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data?.status === "success") {
        setExams(res.data.exams || []);
      }
    } catch (err) {
      console.error("Failed to fetch exams", err);
    }
  };

  const handleSave = async () => {
    const token = getAuthToken();
    const url = formData.id
      ? `${appConstants.API_ROOT_URL}update-exam`
      : `${appConstants.API_ROOT_URL}create-exam`;

    try {
      const res = await axios.post(url, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.status === "success") {
        fetchExams();
        setShowModal(false);
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      console.error("Error saving exam", err);
      alert("Failed to save exam");
    }
  };

  const openModal = (exam = null) => {
    if (exam) {
      setFormData(exam);
    } else {
      setFormData({
        id: null,
        exam_type_id: "",
        name: "",
        batch_id: "",
        subject_id: "",
        staff_id: "",
        total_mark: "",
        duration_minutes: "",
        exam_date: "",
        mode: "Objective",
        status_id: ""
      });
    }
    setShowModal(true);
  };

  const handleMarkEntry = (exam) => {
    navigate(`/exam-mark-entry/${exam.id}`);
  }
  

  return (
    <Layout>
      <h2>Exam Management</h2>
      <Button variant="primary" onClick={() => openModal()}>Declare Exam</Button>
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>#</th>
            <th>Exam Name</th>
            <th>Type</th>
            <th>Batch</th>
            <th>Subject</th>
            <th>Coordinator</th>
            <th>Mark</th>
            <th>Duration</th>
            <th>Date</th>
            <th>Mode</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
        {(exams || []).map((e, index) => (
  <tr key={e.id}>
    <td>{index + 1}</td>
    <td>{e.name}</td>
    <td>{e.exam_type}</td>
    <td>{e.batch_name}</td>
    <td>{e.subject_name}</td>
    <td>{e.staff_name}</td>
    <td>{e.total_mark}</td>
    <td>{e.duration_minutes} mins</td>
    <td>{e.exam_date}</td>
    <td>{e.mode}</td>
    <td>{e.status_label}</td>
    <td>
      <Button variant="warning" size="sm" onClick={() => openModal(e)}>Edit</Button>
      <Button variant="warning" size="sm" onClick={() => handleMarkEntry(e)}>Marks</Button>
    </td>
  </tr>
))}

        </tbody>
      </Table>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{formData.id ? "Edit Exam" : "Declare Exam"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Exam Name</Form.Label>
              <Form.Control
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Exam Type</Form.Label>
              <Form.Select
                value={formData.exam_type_id}
                onChange={(e) => setFormData({ ...formData, exam_type_id: e.target.value })}>
                <option value="">Select</option>
                {(examTypes || []).map((t) => (
                  <option key={t.id} value={t.id}>{t.name}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Batch</Form.Label>
              <Form.Select
                value={formData.batch_id}
                onChange={(e) => setFormData({ ...formData, batch_id: e.target.value })}>
                <option value="">Select</option>
                {(batches || []).map((b) => (
                  <option key={b.id} value={b.id}>
                  {b.class_name} {b.division}
                </option>
                
                ))}
              </Form.Select>
            </Form.Group>
                    <Form.Group className="mb-3">
                    <Form.Label>Subject</Form.Label>
                    <Form.Select
                        value={formData.subject_id}
                        onChange={(e) => setFormData({ ...formData, subject_id: e.target.value })}>
                        <option value="">Select</option>
                        {(subjects || []).map((s) => (
                        <option key={s.id} value={s.id}>{s.name}</option>
                        ))}
                    </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
        <Form.Label>Coordinator</Form.Label>
        <Form.Select
            value={formData.staff_id}
            onChange={(e) => setFormData({ ...formData, staff_id: e.target.value })}>
            <option value="">Select</option>
            {staff.map((s) => (
            <option key={s.id} value={s.id}>{s.name}</option>
            ))}
        </Form.Select>
        </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Total Mark</Form.Label>
              <Form.Control
                type="number"
                value={formData.total_mark}
                onChange={(e) => setFormData({ ...formData, total_mark: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Duration (minutes)</Form.Label>
              <Form.Control
                type="number"
                value={formData.duration_minutes}
                onChange={(e) => setFormData({ ...formData, duration_minutes: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Exam Date</Form.Label>
              <Form.Control
                type="date"
                value={formData.exam_date}
                onChange={(e) => setFormData({ ...formData, exam_date: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Mode</Form.Label>
              <Form.Select
                value={formData.mode}
                onChange={(e) => setFormData({ ...formData, mode: e.target.value })}>
                <option value="Objective">Objective</option>
                <option value="Descriptive">Descriptive</option>
              </Form.Select>
            </Form.Group>
            <Form.Group>
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={formData.status_id}
              onChange={(e) => setFormData({ ...formData, status_id: e.target.value })}
            >
              <option value="">Select Status</option>
              {statuses.map(status => (
                <option key={status.id} value={status.id}>{status.label}</option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
          <Form.Label>Parent Exam (Optional)</Form.Label>
          <Form.Select
            value={formData.parent_exam_id || ""}
            onChange={(e) => setFormData({ ...formData, parent_exam_id: e.target.value || null })}
          >
            <option value="">None</option>
            {(parentExams || []).map((exam) => (
              <option
                key={exam.id}
                value={exam.id}
                disabled={formData.id && formData.id === exam.id} // prevent selecting self
              >
                {exam.name} ({exam.exam_date})
              </option>
            ))}
          </Form.Select>
        </Form.Group>

          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={handleSave}>Save</Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
};

export default ExamManagement;
